<template>
  <div>
    <v-dialog v-model="macDialog" persistent max-width="900">
      <v-card>
        <v-card-title class="title px-4 pb-0">
          <v-flex>
            <v-layout class="align-center">
              <div class="font-weight-bold">MACs</div>
              <div class="ml-4 font-weight-regular">
                <p
                  class="my-3"
                >Dealer: {{ selectedOrder.dealerID }} - {{ selectedOrder.dealerFullName }}</p>
                <p class="my-3">Order: {{ selectedOrder.orderID }} - {{ selectedOrder.orderString }}</p>
              </div>
            </v-layout>
          </v-flex>
        </v-card-title>
        <v-card-text class="pb-0 px-4 mb-3">
          <!-- <ag-grid-vue
            style="height: 328px;"
            class="ag-theme-balham mb-4"
            :gridOptions="gridOptions"
            @grid-ready="onGridReady"
            @rowSelected="getSelectedRows()"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            rowSelection="multiple"
            :rowData="inventoryDetails"
            pagination
            suppressRowClickSelection
            rowMultiSelectWithClick
            paginationAutoPageSize
          ></ag-grid-vue> -->
          <ag-grid-vue
            style="height: 328px;"
            class="ag-theme-balham mb-4"
            :gridOptions="gridOptions"
            @grid-ready="onGridReady"
            @rowSelected="getSelectedRows()"
            @rowDataChanged="selectAll"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            rowSelection="multiple"
            :rowData="filteredInventory"
            @first-data-rendered="selectAll"
            :suppressRowClickSelection="true"
          ></ag-grid-vue>

          <v-card
            elevation="2"
            outlined
            tile
            class="px-4 py-2">
            
            <v-flex>
              <v-layout>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn 
                      id="btnCopy"
                      color="primary"
                      small
                      @click="copyToClipBoad"
                      :disabled="disable"
                      class="ml-0"
                      v-on="on">
                      Copy to Clipboard
                    </v-btn>
                  </template>
                  <span>Copied to Clipboard</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <v-btn v-if="1 == 2" color="primary" medium :disabled="disable" class="mr-0">Remove</v-btn>
              </v-layout>
            </v-flex>
            <v-flex ref="copyMac" v-if="macDetails.length > 0" class="py-2">
              <v-layout class="justify-center" v-for="(item, index) in macDetails" :key="index">
                <div class="mb-0">
                  <span class="px-3">{{ item.product }}</span>
                  <span class="px-3">{{ item['Mac Address'] ? ' ' + item['Mac Address'] : ' ' + item['SERIAL/LOTNUMBER'] }}</span>
                </div>
              </v-layout>
            </v-flex>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="px-3 pb-3">
            <v-btn color="primary" medium @click="close()">Close</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <copyable-text
      :copyableDialog="copyableDialog"
      :component="'mac'"
      :copyableData="macDetails"
      @close="copyableDialog = false"
    ></copyable-text>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);
import CopyableText from "@/components/mia/copyable-text";
import { AgGridVue } from "ag-grid-vue";
import { mapGetters } from "vuex";

export default {
  name: "MacDetails",
  props: {
    macDialog: { type: Boolean, required: true },
  },
  components: {
    CopyableText,
    AgGridVue,
  },
  data () {
    return {
      macDetails: [],
      copyableDialog: false,
      gridOptions: null,
      columnDefs: null,
      defaultColDef: null,
      rowData: null,
      gridApi: null,
      disable: true,
    };
  },
  beforeMount () {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      { headerName: "Product", field: "product", sortable: true, filter: true },
      {
        headerName: "MAC",
        field: "Mac Address",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Serial",
        field: "SERIAL/LOTNUMBER",
        sortable: true,
        filter: true,
      },
      { headerName: "Status", field: "status", sortable: true, filter: true },
      {
        headerName: "Select",
        field: "select",
        checkboxSelection: true,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        headerCheckboxSelection: true,
      },
    ];
    vm.defaultColDef = {
      flex: 1,
      minWidth: 100,
    };
  },
  mounted() {
    this.selectAll()
  },
  methods: {
    ...mapOrderActions(["removeMacFromHardware"]),
    onGridReady (params) {
      let vm = this;
      vm.gridApi = params.api;
    },
    getSelectedRows () {
      let vm = this;
      const selectedData = vm.gridApi.getSelectedRows();
      vm.macDetails = selectedData;
      document.getElementById("btnCopy").click();
    },
    close () {
      let vm = this;
      // vm.gridApi.deselectAll();
      vm.$emit("close");
    },
    removeMac () {
      let vm = this
      vm.removeMacFromHardware()
    },
    copyToClipBoad() {
      let element = this.$refs.copyMac;
      var range;

      if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
      document.execCommand("copy");
    },
    selectAll() {
      if(this.filteredInventory.length > 0) {
        this.gridApi.selectAll()
        this.$nextTick(() => {
          document.getElementById("btnCopy").click();
        })

      }
    }
  },
  computed: {
    ...mapGetters("orders", ["selectedOrder", "inventoryDetails"]),
    filteredInventory() {
      let vm = this;
      if(!vm.inventoryDetails) return;
      
      return vm.inventoryDetails;
    }
  },
  watch: {
    macDetails: function () {
      let vm = this;
      if (vm.macDetails.length > 0) {
        vm.disable = false;
        this.$nextTick(() => {
          document.getElementById("btnCopy").click();
        })
      }
      else vm.disable = true;
    },
  },
};
</script>
<style scoped>
th {
    background-color: #ffffff;
}

.preview {
  text-align: right !important;
}
</style>
